import {
	Flex,
	FlexChild,
	Typography,
	TextColors,
	BorderRadius,
	BackgroundColors,
	Grid,
	FontFamilies,
} from "@abel-technologies-as/components";
import styled from "styled-components";
import { useState } from "react";
import { EditDhcModal } from "../edit-dhc-modal";

import { useOutletContext } from "react-router";
import { DhcDetails } from "../../types";
import { valueOrFallback } from "@/shared/utils";
import { useTranslation } from "react-i18next";

type DhcDetailsContext = { dhcDetails?: DhcDetails };

const Box = styled.div`
	padding: 24px;
	background-color: ${BackgroundColors.PrimaryAlt};
	border-radius: ${BorderRadius.XL}px;
`;

const InformationSection = () => {
	const { t } = useTranslation("dhc");
	const { dhcDetails } = useOutletContext<DhcDetailsContext>();
	const [isEditDhcModalOpen, setIsEditDhcModalOpen] = useState<boolean>(false);

	return (
		<>
			<FlexChild flexBasis="50%" flexGrow={0} flexShrink={0}>
				<Flex margin="0 0 16px 0" justifyContent="space-between">
					<Typography
						lineHeight="28px"
						fontSize="18px"
						color={TextColors.Primary}
						fontWeight={600}
						fontFamily={FontFamilies.InterSemiBold}>
						{t("information")}
					</Typography>
					{/* <Button
						borderSize={"1px"}
						filled
						size={ButtonSize.SMALL}
						backgroundColor={BackgroundColors.Primary}
						borderRadius={`${BorderRadius.MD}px`}
						iconBefore={<SmallPencil width="15" height="15" color={TextColors.Secondary} />}
						textColor="white"
						boxShadow={"0px 1px 2px 0px rgba(16, 24, 40, 0.05)"}
						borderColor={BorderColors.Primary}
						onClick={() => null}>
						<Typography
							margin="0 0 0 6px"
							color={TextColors.Secondary}
							lineHeight="18px"
							fontFamily={FontFamilies.InterSemiBold}
							fontSize="14px"
							fontWeight={"600"}
							variant="p">
							Edit
						</Typography>
					</Button> */}
				</Flex>
				<Box>
					<Flex
						margin="0 0 20px 0"
						mediaSm="flex-direction: column;"
						gap="16px"
						justifyContent="space-between"
						alignItems="flex-start">
						<FlexChild mediaSm="width: 100%;" flexBasis="50%" flexGrow={1} flexShrink={1}>
							<Grid gap="16px" mediaSm="grid-template-columns: repeat(2, 1fr)">
								<Flex flexDirection="column" gap="2px" alignItems="flex-start">
									<Typography
										fontWeight={600}
										color={TextColors.Primary}
										fontSize="14px"
										lineHeight="20px"
										fontFamily={FontFamilies.InterSemiBold}>
										{t("phone")}
									</Typography>
									<Typography
										fontFamily="Inter-Medium"
										fontWeight={400}
										fontSize="14px"
										lineHeight="20px"
										color={TextColors.Quaternary}>
										{valueOrFallback(dhcDetails?.phone) === "-" ? "-" : `+${dhcDetails?.phone}`}
									</Typography>
								</Flex>
								<Flex flexDirection="column" gap="2px" alignItems="flex-start">
									<Typography
										fontWeight={600}
										color={TextColors.Primary}
										fontSize="14px"
										lineHeight="20px"
										fontFamily="Inter-Semibold">
										{t("sex")}
									</Typography>
									<Typography
										fontFamily="Inter-Medium"
										fontWeight={400}
										fontSize="14px"
										lineHeight="20px"
										color={TextColors.Quaternary}>
										{valueOrFallback(dhcDetails?.sex)}
									</Typography>
								</Flex>
								<Flex flexDirection="column" gap="2px" alignItems="flex-start">
									<Typography
										fontWeight={600}
										color={TextColors.Primary}
										fontSize="14px"
										lineHeight="20px"
										fontFamily="Inter-Semibold">
										{t("qa")}
									</Typography>
									<Typography
										fontFamily="Inter-Medium"
										fontWeight={400}
										fontSize="14px"
										lineHeight="20px"
										color={TextColors.Quaternary}>
										{valueOrFallback(dhcDetails?.qaName)}
									</Typography>
								</Flex>
								{/* <Flex flexDirection="column" gap="2px" alignItems="flex-start">
									<Typography
										fontWeight={600}
										color={TextColors.Primary}
										fontSize="14px"
										lineHeight="20px"
										fontFamily="Inter-Semibold">
										Address
									</Typography>
									<Typography
										fontFamily="Inter-Medium"
										fontWeight={400}
										fontSize="14px"
										lineHeight="20px"
										color={TextColors.Quaternary}>
										🇳🇴 NO
									</Typography>
								</Flex> */}
								{/* <Flex flexDirection="column" gap="2px" alignItems="flex-start">
									<Typography
										fontWeight={600}
										color={TextColors.Primary}
										fontSize="14px"
										lineHeight="20px"
										fontFamily="Inter-Semibold">
										User ID
									</Typography>
									<Typography
										fontFamily="Inter-Medium"
										fontWeight={400}
										fontSize="14px"
										lineHeight="20px"
										color={TextColors.Quaternary}>
										usr_LSsupzl5gCLp7n
									</Typography>
								</Flex> */}
								{/* <Flex flexDirection="column" gap="2px" alignItems="flex-start">
									<Typography
										fontWeight={600}
										color={TextColors.Primary}
										fontSize="14px"
										lineHeight="20px"
										fontFamily="Inter-Semibold">
										User Since
									</Typography>
									<Typography
										fontFamily="Inter-Medium"
										fontWeight={400}
										fontSize="14px"
										lineHeight="20px"
										color={TextColors.Quaternary}>
										Apr 7, 2022
									</Typography>
								</Flex> */}
								{/* <Flex flexDirection="column" gap="2px" alignItems="flex-start">
									<Typography
										fontWeight={600}
										color={TextColors.Primary}
										fontSize="14px"
										lineHeight="20px"
										fontFamily="Inter-Semibold">
										Bank account
									</Typography>
									<Flex gap="8px" alignItems="center">
										<Typography
											fontFamily="Inter-Medium"
											fontWeight={400}
											fontSize="14px"
											lineHeight="20px"
											color={TextColors.Quaternary}>
											1201 94 25911
										</Typography>
										<CheckMark width="16" height="16" color={TextColors.Success_500} />
									</Flex>
								</Flex> */}
								{/* <Flex flexDirection="column" gap="2px" alignItems="flex-start">
									<Typography
										fontWeight={600}
										color={TextColors.Primary}
										fontSize="14px"
										lineHeight="20px"
										fontFamily="Inter-Semibold">
										Education
									</Typography>
									<Typography
										fontFamily="Inter-Medium"
										fontWeight={400}
										fontSize="14px"
										lineHeight="20px"
										color={TextColors.Quaternary}>
										Bachelor i fysikk
									</Typography>
								</Flex> */}
								{/* <Flex flexDirection="column" gap="2px" alignItems="flex-start">
									<Typography
										fontWeight={600}
										color={TextColors.Primary}
										fontSize="14px"
										lineHeight="20px"
										fontFamily="Inter-Semibold">
										Elegibility
									</Typography>
									<Typography
										fontFamily="Inter-Medium"
										fontWeight={400}
										fontSize="14px"
										lineHeight="20px"
										color={TextColors.Quaternary}>
										Nav, MITT Beste, Doctors, Insurance
									</Typography>
								</Flex> */}
								{/* <Flex flexDirection="column" gap="2px" alignItems="flex-start">
									<Typography
										fontWeight={600}
										color={TextColors.Primary}
										fontSize="14px"
										lineHeight="20px"
										fontFamily="Inter-Semibold">
										Languages
									</Typography>
									<Typography
										fontFamily="Inter-Medium"
										fontWeight={400}
										fontSize="14px"
										lineHeight="20px"
										color={TextColors.Quaternary}>
										Norwegian, English
									</Typography>
								</Flex> */}
							</Grid>
						</FlexChild>
					</Flex>
				</Box>
				{/* <FlexChild width="100%" margin="30px 0 0 0">
					<Typography
						margin="0 0 10px 0"
						textAlign="left"
						color={TextColors.Primary}
						fontFamily={FontFamilies.InterSemiBold}
						fontWeight={600}
						fontSize="18px"
						lineHeight="28px">
						User Role
					</Typography>
					<Select
						showSearchBar
						title="Select User Role"
						value={dhc}
						helperText="Type to search for your DHC."
						items={["Test", "Test2", "Test3"]}
						onChange={(value) => setDhc(value as string)}></Select>
				</FlexChild> */}
				{/* <FlexChild width="100%" margin="30px 0 0 0">
					<Typography
						margin="0 0 10px 0"
						textAlign="left"
						color={TextColors.Primary}
						fontFamily={FontFamilies.InterSemiBold}
						fontWeight={600}
						fontSize="18px"
						lineHeight="28px">
						Assigned QA
					</Typography>
					<Select
						showSearchBar
						title="Select User Role"
						value={dhc}
						items={["Test", "Test2", "Test3"]}
						onChange={(value) => setDhc(value as string)}></Select>
				</FlexChild> */}
			</FlexChild>
			<EditDhcModal open={isEditDhcModalOpen} setOpen={setIsEditDhcModalOpen} />
		</>
	);
};

export { InformationSection };
